import { render } from "./InvestasiDataKBLI.vue?vue&type=template&id=634c85fd"
import script from "./InvestasiDataKBLI.vue?vue&type=script&lang=js"
export * from "./InvestasiDataKBLI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__